import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError, tap } from 'rxjs/operators';
import { SharedService } from '../services/shared.service';
import { ITokenResponse } from '../interfaces/token-response';
import { IDisbursementSession } from '../interfaces/disbursement-session';

@Injectable({
  providedIn: 'root'
})
export class DisbursementSessionService {

  private disbursementSessionUrl = '/client/disbursement-session';
  private customerValidationUrl = '/client/disbursement-session/cv';  
  private paymentTokenUrl = '/client/disbursement-session/post-token';

  constructor(
    private http: HttpClient,
    private sharedService: SharedService
  ) { }

  public getDisbursementSession(envRegion: string, sessionId: string): Observable<IDisbursementSession> {
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) + this.disbursementSessionUrl;
    let headers = new HttpHeaders()
      .set('Authorization', this.sharedService.getAppBasicAuth())
      .set('session-id', sessionId);
    return this.http.get<IDisbursementSession>(url, { headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public validateCustomer(envRegion: string, sessionId: string, cvCredentials: Map<string,string>): Observable<ITokenResponse> {
    let headers = new HttpHeaders()
      .set('session-id', sessionId);
    var url = this.sharedService.getDisbursementsBaseUrl(envRegion) + this.customerValidationUrl; 
    const request = Object.fromEntries(cvCredentials);
    return this.http.post<ITokenResponse>(url, request, {headers: headers, responseType: 'json'})
    .pipe(
      tap(data => {}
        // console.log('All: ' + JSON.stringify(data))
      ),
      catchError(this.sharedService.handleError)
      // catchError(this.sharedService.handleError2<ITokenResponse>('validateCustomer' ))
    ) 
  }

  public postTokenId(envRegion: string, sessionId: string, paymentType: string, paymentTokenId: string): Observable<any> {
    let headers = new HttpHeaders()
    .set('session-id', sessionId);
    let request = 
    {
      "paymentType": paymentType,
      "paymentTokenId": paymentTokenId
    };
    var url = this.sharedService.getDisbursementsBaseUrl(envRegion) + this.paymentTokenUrl; 
    return this.http.post<any>(url, request, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    ) 
  }

}
